const initialState = {
  bar: 'baz',
  foo: '',
};

const ExampleReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'EXAMPLE': {
      return {
        ...state,
        foo: action.foo,
      };
    }
    default:
      return state;
  }
};

export default ExampleReducer;



// WEBPACK FOOTER //
// ./src/redux/ExampleReducer.js